import { ui } from '@/constants';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgIngredientsBanner',
})
export default class CmgIngredientsBanner extends Vue {
  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.tablet;
  }
}
